import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../../../css/dashboard.css"
import axios from 'axios';
import CommonTable from "../../component/table_list/common_table";
import CommonTableRow from "../../component/table_list/common_tablerow";
import CommonTableColumn from "../../component/table_list/common_tablecolumn";
import Pagination from "react-js-pagination";
import styled from "styled-components"
import { formatDate } from "../../utils/format_date"
import { useAuthContext } from '../../common/ProtectedLayout';

function Coupon(props) {

    const location = useLocation();
    const navigate = useNavigate();
    const [isValidAccess, setIsValidAccess] = useState(false); // 유효한 접근 상태

    const [couponList, setCouponList] = useState([]);
    const [couponInfo, setCouponInfo] = useState({
        regist_count: '10',
        balance_count: '10',
        kind: '유료쿠폰',
        discount: '10'
    });
    const [page, setPage] = useState(1);
    const items = 10;
    const hadlePageChange = (page) => { setPage(page) };
    const [reserveCount, setReserveCount] = useState([]);
    const auth = useAuthContext();

    const modalCorrective = useRef();

    const getCouponRegist = async () => {
        try {
            const getPage = (page - 1) * 10;
            const reserve_result = await axios.get(`/CouponRegist/${getPage}`);
            setCouponList(reserve_result.data.message);
        } catch (error) {
            console.error('Error fetching reservation count:', error.message);
        }
    };
    const getReserveCount = async () => {
        try {
            const reserve_result = await axios.get('/CouponRegistCount');
            setReserveCount(reserve_result.data.message);
        } catch (error) {
            console.error('Error fetching reservation count:', error.message);
        }
    }
    useEffect(() => {
        getCouponRegist();
    }, [page])

    useEffect(() => {
        setIsValidAccess(true);
        getCouponRegist();
        getReserveCount();
    }, [location.state, navigate]);

    // 유효한 접근이 아닌 경우 렌더링하지 않음
    if (!isValidAccess) {
        return null;
    }

    const startCorrective = () => {
        generateCouponNumber();
        modalCorrective.current.showModal();
    }

    const postCorrective = async () => {
        const requestData = {
            number: couponInfo.number || '',
            name: couponInfo.name || '',
            kind: couponInfo.kind || '유료',
            amount: couponInfo.amount || '',
            discount: couponInfo.discount || '10',
            user_price: couponInfo.user_price || '',
            regist_count: couponInfo.regist_count || '10',
            balance_count: couponInfo.balance_count || '10',
            validity_start_date: couponInfo.validity_start_date || '',
            validity_end_date: couponInfo.validity_end_date || '',
            use_date: couponInfo.use_date || '',
            issuer: couponInfo.issuer || ''
        };

        try {
            const result = await axios.post('/CouponRegist', requestData);
            alert(result.data.message);
            modalCorrective.current.close();
            getCouponRegist(); // Refresh the list of coupons after registration
        } catch (error) {
            console.error('Error:', error.message);
        }
    }
    const calculateUserPrice = (amount, discount) => {
        if (!amount || !discount) return '';
        const discountRate = parseFloat(discount) / 100;
        return Math.floor(amount - (amount * discountRate)); // 소수점 제거
    };

    const ChangeName = (e) => setCouponInfo(prevState => ({ ...prevState, name: e.target.value }));
    const ChangeKind = (e) => setCouponInfo(prevState => ({ ...prevState, kind: e.target.value }));
    const ChangeAmount = (e) => {
        const amount = e.target.value;
        if (!isNaN(amount)) { // 숫자만 입력 가능하도록 체크
            setCouponInfo(prevState => {
                const discount = prevState.discount || '10'; // 할인률이 없으면 10%로 설정
                return {
                    ...prevState,
                    amount: amount,
                    discount: discount, // 초기 할인률이 10%로 설정
                    user_price: calculateUserPrice(amount, discount) // 금액이 변경될 때도 구매금액 재계산
                };
            });
        }
    };
    const ChangeDiscount = (e) => {
        const discount = e.target.value;
        setCouponInfo(prevState => ({
            ...prevState,
            discount: discount,
            user_price: calculateUserPrice(prevState.amount, discount) // 할인률에 따라 구매금액 자동 계산
        }));
    };
    const ChangeRegistCount = (e) => {
        const newRegistCount = e.target.value;
        setCouponInfo(prevState => ({
            ...prevState,
            regist_count: newRegistCount,
            balance_count: newRegistCount // 발행수량을 남은수량과 동일하게 설정
        }));
    };
    const ChangeStartDate = (e) => setCouponInfo(prevState => ({ ...prevState, validity_start_date: e.target.value }));
    const ChangeEndDate = (e) => setCouponInfo(prevState => ({ ...prevState, validity_end_date: e.target.value }));
    const ChangeUseDate = (e) => setCouponInfo(prevState => ({ ...prevState, use_date: e.target.value }));
    const ChangeIssuer = (e) => setCouponInfo(prevState => ({ ...prevState, issuer: e.target.value }));


    const generateCouponNumber = async () => {
        const date = new Date();
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        // Fetch the last sequence number for today
        try {
            const response = await axios.get(`/CouponSequence/${year}${month}${day}`);
            let lastSequence = response.data.lastSequence || 0;

            // Increment sequence for the new coupon
            const newSequence = (lastSequence + 1).toString().padStart(3, '0');

            const couponNumber = `G-${year}${month}${day}L${newSequence}`;
            setCouponInfo(prevState => ({ ...prevState, number: couponNumber }));

        } catch (error) {
            console.error('Error fetching sequence number:', error);
            alert('Error generating coupon number');
        }
    };

    return (
        <div className="dashboard-container">
            <div className="content-container">
                <div style={{ marginTop: '50px' }}>
                    <CommonTable headerTitle={['No', '쿠폰번호', '발급자', '발급일자', '쿠폰종류', '쿠폰이름', '할인률', '소비자가격']}>
                        {
                            couponList.map((reserve, index) => {
                                return (
                                    <CommonTableRow key={index} idx={reserve.idx} beforePage={'/coupon'} kind={'coupon'}>
                                        <CommonTableColumn>{reserveCount - ((page - 1) * 10) - index}</CommonTableColumn>
                                        <CommonTableColumn>{reserve.number}</CommonTableColumn>
                                        <CommonTableColumn>{reserve.issuer}</CommonTableColumn>
                                        <CommonTableColumn>{formatDate(reserve.regist_date)}</CommonTableColumn>
                                        <CommonTableColumn>{reserve.kind}</CommonTableColumn>
                                        <CommonTableColumn>{reserve.name}</CommonTableColumn>
                                        <CommonTableColumn>{reserve.discount}%</CommonTableColumn>
                                        <CommonTableColumn>{reserve.user_price}</CommonTableColumn>
                                    </CommonTableRow>
                                )
                            })
                        }
                    </CommonTable>
                </div>

                {/* 변경된 버튼 컨테이너 */}
                <ButtonContainer>
                    <PrimaryButton onClick={startCorrective}>쿠폰생성</PrimaryButton>
                </ButtonContainer>

                <PaginationBox>
                    <Pagination
                        activePage={page}
                        itemsCountPerPage={items}
                        totalItemsCount={reserveCount}
                        pageRangeDisplayed={10}
                        onChange={hadlePageChange}>
                    </Pagination>
                </PaginationBox>
            </div>

            {/* 변경된 모달 스타일 */}
            <StyledDialog ref={modalCorrective} style={{ width: '800px' }}>
                <DialogHeader>
                    <h3>쿠폰 생성</h3>
                    <CloseButton onClick={() => modalCorrective.current.close()}>&times;</CloseButton>
                </DialogHeader>
                <DialogContent>
                    <InputGroup>
                        <Label>쿠폰번호</Label>
                        <StyledInput value={couponInfo.number || ''} readOnly style={{ backgroundColor: '#f5f5f5' }} />
                    </InputGroup>

                    <InputGroup>
                        <Label>쿠폰이름</Label>
                        <StyledInput value={couponInfo.name || ''} onChange={ChangeName} />
                    </InputGroup>

                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                        <InputGroup>
                            <Label>쿠폰종류</Label>
                            <StyledSelect value={couponInfo.kind || '유료쿠폰'} onChange={ChangeKind}>
                                <option value="유료쿠폰">유료</option>
                                <option value="무료쿠폰">무료</option>
                            </StyledSelect>
                        </InputGroup>
                        <InputGroup>
                            <Label>할인률</Label>
                            <StyledSelect value={couponInfo.discount || '10'} onChange={ChangeDiscount}>
                                {[10, 20, 30, 40, 50, 60, 70, 80, 90].map(val => (
                                    <option key={val} value={val}>{val}%</option>
                                ))}
                            </StyledSelect>
                        </InputGroup>
                    </div>

                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                        <InputGroup>
                            <Label>쿠폰금액</Label>
                            <StyledInput value={couponInfo.amount || ''} onChange={ChangeAmount} placeholder="금액 입력" />
                        </InputGroup>
                        <InputGroup>
                            <Label>구매금액</Label>
                            <StyledInput value={couponInfo.user_price || ''} readOnly style={{ backgroundColor: '#f5f5f5' }} />
                        </InputGroup>
                    </div>

                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                        <InputGroup>
                            <Label>발행수량</Label>
                            <StyledSelect value={couponInfo.regist_count || '10'} onChange={ChangeRegistCount}>
                                <option value="10">10장</option>
                                <option value="100">100장</option>
                                <option value="1000">1000장</option>
                                <option value="10000">10000장</option>
                            </StyledSelect>
                        </InputGroup>
                        <InputGroup>
                            <Label>남은수량</Label>
                            <StyledInput value={couponInfo.balance_count || ''} readOnly style={{ backgroundColor: '#f5f5f5' }} />
                        </InputGroup>
                    </div>

                    <InputGroup>
                        <Label>발행기간 (시작 ~ 종료)</Label>
                        <div style={{ display: 'flex', gap: '10px' }}>
                            <StyledInput type="date" value={couponInfo.validity_start_date || ''} onChange={ChangeStartDate} />
                            <StyledInput type="date" value={couponInfo.validity_end_date || ''} onChange={ChangeEndDate} />
                        </div>
                    </InputGroup>

                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                        <InputGroup>
                            <Label>사용기간</Label>
                            <StyledSelect value={couponInfo.use_date || '1'} onChange={ChangeUseDate}>
                                <option value="1">발급 후 1년이내</option>
                                <option value="2">발급 후 2년이내</option>
                                <option value="3">발급 후 3년이내</option>
                                <option value="4">발급 후 4년이내</option>
                                <option value="5">발급 후 5년이내</option>
                            </StyledSelect>
                        </InputGroup>
                        <InputGroup>
                            <Label>발급자</Label>
                            <StyledInput value={couponInfo.issuer || ''} onChange={ChangeIssuer} />
                        </InputGroup>
                    </div>
                </DialogContent>
                <DialogActions>
                    <OutlineButton onClick={() => modalCorrective.current.close()}>취소</OutlineButton>
                    <PrimaryButton onClick={postCorrective}>적용</PrimaryButton>
                </DialogActions>
            </StyledDialog>
        </div >
    );
}

// --- Styled Components (Consistent with Manager/Staff) ---

const BaseButton = styled.button`
    padding: 8px 18px; 
    border-radius: 8px; 
    font-weight: 600;
    cursor: pointer; 
    transition: all 0.2s; 
    border: none; 
    font-size: 0.9rem;
`;

const PrimaryButton = styled(BaseButton)`
    background-color: #007bff;
    color: white;
    &:hover { background-color: #0056b3; }
`;

const OutlineButton = styled(BaseButton)`
    background-color: white; 
    border: 1px solid #ccc; 
    color: #555;
    &:hover { background-color: #f9f9f9; border-color: #bbb; }
`;

const ButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 1rem;
    gap: 10px;
    width: 90%;
    margin-left: auto;
    margin-right: auto;
`;

const StyledDialog = styled.dialog`
    border: none; 
    border-radius: 16px; 
    padding: 0;
    box-shadow: 0 10px 40px rgba(0,0,0,0.25);
    &::backdrop { background: rgba(0, 0, 0, 0.6); }
`;

const DialogHeader = styled.div`
    padding: 16px 20px; 
    border-bottom: 1px solid #eee;
    display: flex; 
    justify-content: space-between; 
    align-items: center;
    h3 { margin: 0; font-size: 1.2rem; font-weight: 700; }
`;

const DialogContent = styled.div`
    padding: 24px; 
    background: #fff; 
    max-height: 80vh; 
    overflow-y: auto;
    display: flex; 
    flex-direction: column;
`;

const DialogActions = styled.div`
    padding: 16px 20px; 
    border-top: 1px solid #eee;
    display: flex; 
    justify-content: flex-end; 
    gap: 10px;
`;

const CloseButton = styled.button`
    background: none; 
    border: none; 
    font-size: 1.8rem; 
    cursor: pointer; 
    color: #999; 
    line-height: 1;
    &:hover { color: #333; }
`;

const InputGroup = styled.div`
    margin-bottom: 1rem;
`;

const Label = styled.label`
    display: block;
    margin-bottom: 0.5rem;
    color: #555;
    font-weight: 500;
    font-size: 0.9rem;
`;

const StyledInput = styled.input`
    width: 100%;
    padding: 0.6rem;
    border: 1px solid #ddd;
    border-radius: 6px;
    font-size: 0.95rem;
    box-sizing: border-box;

    &:focus {
        outline: none;
        border-color: #007bff;
        box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);
    }
`;

const StyledSelect = styled.select`
    width: 100%;
    padding: 0.6rem;
    border: 1px solid #ddd;
    border-radius: 6px;
    font-size: 0.95rem;
    box-sizing: border-box;
    background-color: white;

    &:focus {
        outline: none;
        border-color: #007bff;
        box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);
    }
`;

const PaginationBox = styled.div`
  .pagination { display: flex; justify-content: center; margin-top: 15px;}
  ul { list-style: none; padding: 0; }
  ul.pagination li {
    display: inline-block;
    width: 30px;
    height: 30px;
    border: 1px solid #e2e2e2;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem; 
  }
  ul.pagination li:first-child{ border-radius: 5px 0 0 5px; }
  ul.pagination li:last-child{ border-radius: 0 5px 5px 0; }
  ul.pagination li a { text-decoration: none; color: #337ab7; font-size: 1rem; }
  ul.pagination li.active a { color: white; }
  ul.pagination li.active { background-color: #337ab7; }
  ul.pagination li a:hover,
  ul.pagination li a.active { color: blue; }
`;

export default Coupon;